import { Box, Stack, useMediaQuery } from '@mui/material';
import React, { memo, useCallback, useEffect, useState, useRef } from 'react';
import { TransactionSummary } from './summary';
import { useThemes } from '../../../components/Theme/theme';
import { SimplePeriodDropdown } from '../../../components';
import { useSimplePeriodDropdown } from '../../../components/_components/Inputs/SimplePeriodDropdown/useSimplePeriod';
import Checkbox from '../../InvoiceSettings/components/checkbox';

const Header = ({
  PeriodDropDownModalRef,
  data,
  setfilters,
  fetchData,
  filters,
  rowsperpage,
  handleOpeningBalanceChange,
  includeOpening,
}) => {
  const matches = useMediaQuery('(max-width:600px)');
  const { theme } = useThemes();

  // Use ref to store current rowsperpage to avoid stale closure
  const rowsperpageRef = useRef(rowsperpage);
  rowsperpageRef.current = rowsperpage;

  const onChangeClick = useCallback(() => {
    setfilters((prev) => ({ ...prev, open: true }));
  }, [setfilters]);
  const onCustomSelection = useCallback(() => {
    setfilters((prev) => ({ ...prev, open: true }));
  }, [setfilters]);
  // Use ref to track if this is initial load to prevent extra fetchData calls
  const isInitialLoadRef = useRef(true);

  const onPeriodDropDownChange = useCallback(
    ({ from: start, to: end }) => {
      console.log({ start, end, currentRowsPerPage: rowsperpageRef.current, isInitialLoad: isInitialLoadRef.current });

      // Only fetch data if it's not an initial load
      if (!isInitialLoadRef.current) {
        fetchData({ start, end, from: rowsperpageRef.current, limit: 0, reset: true });
      }

      setfilters((prev) => ({
        ...prev,
        custom: false,
        start: start,
        end: end,
        endRaw: '',
        startRaw: '',
      }));
    },
    [setfilters, fetchData, includeOpening]
  );

  const { value, onChange: handlePeriodChange } = useSimplePeriodDropdown('custom', {}, onPeriodDropDownChange);
  const [hasLoadedInitialDates, setHasLoadedInitialDates] = useState(false);

  // Load custom date on mount if filters have dates and ensure it only happens once
  useEffect(() => {
    if (filters.start && filters.end && !hasLoadedInitialDates) {
      handlePeriodChange({ from: filters.start, to: filters.end });
      setHasLoadedInitialDates(true);
      // Mark that initial load is complete
      isInitialLoadRef.current = false;
      console.log('loaded initial dates');
    }
  }, [filters.start, filters.end, hasLoadedInitialDates, handlePeriodChange]);

  return (
    <div style={{ padding: '3px 15px' }}>
      <Box
        sx={{
          p: '3px',
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: { xs: 'column', md: 'row' },
        }}
      >
        <Stack direction="row" alignItems="center" spacing={2}>
          <SimplePeriodDropdown title="As on " value={value} onChange={handlePeriodChange} showDateText />
          <Checkbox checked={includeOpening} onChange={handleOpeningBalanceChange} label={'Include Opening Balance'} />
        </Stack>
        <TransactionSummary data={data} matches={matches} />
      </Box>
    </div>
  );
};

export default memo(Header);
